import React, { useContext, useState, useEffect } from 'react';
import './ProductDisplay.css';
import star_icon from '../Assets/star_icon.png';
import star_dull_icon from '../Assets/star_dull_icon.png';
import { ShopContext } from '../../Context/ShopContext';

const ProductDisplay = (props) => {
  const { product } = props;
  const { addToCart } = useContext(ShopContext);
  const [selectedSize, setSelectedSize] = useState(null);

  // تجهيز قائمة الصور
  const thumbnails = [];

  if (product.image_urls && product.image_urls.length > 0) {
    thumbnails.push(...product.image_urls);
  } else if (product.image) {
    thumbnails.push(product.image);
  } else {
    thumbnails.push('http://localhost:4000/images/default-image.jpg'); // حط مسار صورة افتراضية صالحة عندك
  }

  // حالة الصورة المعروضة الرئيسية، تبدأ بأول صورة في المصفوفة
  const [displayImage, setDisplayImage] = useState(thumbnails[0]);

  // تحديث الصورة الرئيسية لو تغير المنتج (مثلاً عند التنقل بين منتجات)
  useEffect(() => {
    setDisplayImage(thumbnails[0]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product]);

  const handleAddToCart = () => {
    if (!selectedSize) {
      alert("Please select a size before adding to cart.");
      return;
    }
    addToCart(product.id, selectedSize);
  };

  return (
    <div className='productdisplay'>
      <div className="productdisplay-left">
        <div className="productdisplay-img-list">
          {thumbnails.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`${product.name} ${index}`}
              onClick={() => setDisplayImage(img)}
              onError={(e) => { e.target.src = 'http://localhost:4000/images/default-image.jpg'; }}
              style={{ cursor: 'pointer', border: displayImage === img ? '2px solid #ff4141' : 'none' }}
            />
          ))}
        </div>
        <div className="productdisplay-img">
          <img
            className='productdisplay-main-img'
            src={displayImage}
            alt={product.name}
            onError={(e) => { e.target.src = 'http://localhost:4000/images/default-image.jpg'; }}
          />
        </div>
      </div>

      <div className="productdisplay-right">
        <h1>{product.name}</h1>
        <div className="productdisplay-right-stars">
          <img src={star_icon} alt="" />
          <img src={star_icon} alt="" />
          <img src={star_icon} alt="" />
          <img src={star_icon} alt="" />
          <img src={star_dull_icon} alt="" />
          <p>(122)</p>
        </div>
        <div className="productdisplay-right-prices">
          <div className="productdisplay-right-price-old">${product.old_price}</div>
          <div className="productdisplay-right-price-new">${product.new_price}</div>
        </div>
        <div className="productdisplay-right-description">
          {product.description || "No description available."}
        </div>

        <div className="productdisplay-right-size">
          <h1>Select size</h1>
          <div className="productdisplay-right-sizes">
            {['S', 'M', 'L', 'XL', 'XXL'].map((size) => (
              <div
                key={size}
                onClick={() => setSelectedSize(size)}
                style={{ border: selectedSize === size ? '2px solid #ff4141' : '' }}
              >
                {size}
              </div>
            ))}
          </div>
          <button onClick={handleAddToCart}>ADD To Cart</button>
        </div>
      </div>
    </div>
  );
};

export default ProductDisplay;






